import React from 'react';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { Surface } from '@americanexpress/dls-react';
import { RoomsContextProvider } from '../contexts/roomsContext';
import RoomsSelector from './Rooms/RoomsSelector';
import { MODULE_NAME } from '../constants/moduleName';
import { ConfigContextProvider } from '../contexts/configContext';
import { RefsContextProvider } from '../contexts/refsContext';

const TravelSearchRoomsTravelers = ({
  locale,
  languageData,
  id: parentId,
  hasRooms,
  hasLabel,
  hasInfants,
  hasPets,
  hasChildrenAges,
  onChange,
  onToggleVisibility,
  maxAdults,
  maxRooms,
  maxInfants,
  maxChildren,
  maxCombinedChildrenAndInfants,
  maxTravelersCap,
  maxTravelersPerRoom,
  defaultChildAge,
  value,
  theme,
  element,
  lob,
  defaultValue,
}) => (
  <IntlProvider locale={locale} messages={languageData}>
    <ConfigContextProvider
      {...{
        defaultChildAge,
        element,
        hasChildrenAges,
        hasInfants,
        hasPets,
        hasRooms,
        maxAdults,
        maxChildren,
        maxCombinedChildrenAndInfants,
        maxTravelersCap,
        maxTravelersPerRoom,
        maxInfants,
        maxRooms,
        hasLabel,
        onChange,
        onToggleVisibility,
        parentId,
        theme,
        value,
        lob,
        defaultValue,
      }}
    >
      <RoomsContextProvider>
        <RefsContextProvider>
          <Surface
            variant={theme === 'blue' ? 'fg-brand' : 'foreground'}
            className="width-full"
            style={{ display: !(theme === 'blue') && 'contents' }}
          >
            <RoomsSelector />
          </Surface>
        </RefsContextProvider>
      </RoomsContextProvider>
    </ConfigContextProvider>
  </IntlProvider>
);

TravelSearchRoomsTravelers.propTypes = {
  locale: PropTypes.string.isRequired,
  languageData: PropTypes.shape({}).isRequired,
  id: PropTypes.string,
  maxAdults: PropTypes.number,
  maxRooms: PropTypes.number,
  maxChildren: PropTypes.number,
  maxInfants: PropTypes.number,
  maxCombinedChildrenAndInfants: PropTypes.number,
  maxTravelersCap: PropTypes.number,
  maxTravelersPerRoom: PropTypes.number,
  defaultChildAge: PropTypes.string,
  onChange: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  value: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
  theme: PropTypes.string,
  hasLabel: PropTypes.bool,
  hasInfants: PropTypes.bool,
  hasPets: PropTypes.bool,
  hasRooms: PropTypes.bool,
  hasChildrenAges: PropTypes.bool,
  element: PropTypes.string,
  lob: PropTypes.string,
  defaultValue: PropTypes.arrayOf(
    PropTypes.shape({})
  ),
};

TravelSearchRoomsTravelers.defaultProps = {
  id: '',
  maxAdults: 4,
  maxRooms: 4,
  maxChildren: 6,
  maxInfants: 6,
  maxCombinedChildrenAndInfants: undefined,
  maxTravelersCap: undefined,
  defaultChildAge: '8',
  theme: 'blue',
  hasLabel: false,
  hasInfants: false,
  hasPets: false,
  hasRooms: true,
  hasChildrenAges: false,
  onChange: () => ({}),
  onToggleVisibility: () => ({}),
  element: 'number-of-travelers',
  lob: '',
  defaultValue: [
    {
      adults: 1,
      children: [],
      infants: [],
    },
  ],
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  await Promise.all([
    dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
  ]);
};

TravelSearchRoomsTravelers.holocron = {
  name: MODULE_NAME,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper(MODULE_NAME)
);

export { TravelSearchRoomsTravelers as TestableTravelSearchRoomsTravelers };

export default hocChain(TravelSearchRoomsTravelers);
